import { render, staticRenderFns } from "./question3.vue?vue&type=template&id=7e61b76d&"
import script from "./question3.vue?vue&type=script&lang=js&"
export * from "./question3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports